<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    width="500"
    class="modal-contact"
  >
    <v-card>
      <v-card-title
        class="headline dark lighten-2 pb-4 justify-center"
        primary-title
      >
        Komm an Bord!
      </v-card-title>

      <v-card-text class="pt-5 dark white--text body-1 text-center">
        <p>Interessiert an den neuen Dimensionen der Virtual und Augmented Reality? Schreib uns gern eine Email oder ruf uns an und lass dich von uns bei einem kostenfreien Erstberatungsgespräch über die Möglichkeiten informieren!</p>
        <v-container class="pa-0 mb-3">
          <v-row>
            <v-col>
              <v-row>
                <v-col class="pb-0 font-weight-bold">
                  Email
                </v-col>
              </v-row>
              <v-row>
                <v-col class="font-weight-bold whitespace-nowrap">
                  <a href="mailto:info@holonative.de" title="Schreib eine Email">info@holonative.de</a>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col class="pb-0 font-weight-bold">
                  Telefon
                </v-col>
              </v-row>
              <v-row>
                <v-col class="font-weight-bold whitespace-nowrap">
                  <a href="tel:+4915788895527" title="Ruf uns an">+49 157 8889 5527</a>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="ma-3" />
        <p class="mt-5">Für aktuelle Updates folge uns auf <strong><a href="https://www.linkedin.com/company/holonative/" target="_blank" title="Folge uns auf LinkedIn">LinkedIn</a></strong>!</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalContact',
  props: { 
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
  .whitespace-nowrap {
    white-space: nowrap;
  }
</style>
